import { c as _c } from "react/compiler-runtime";
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import useIsBankImprint from '@/hooks/useIsBankImprint';
import { capitalize, formatPrice } from '@winelidays/wld-tsx-2/utils';
import MoreBookingDetail from '../../MoreBookingDetail';
const BookingDetailMainPrice = t0 => {
    const $ = _c(43);
    const { modal, onOpenBookingDetailModal, entity, calculatedPrice, cancellation } = t0;
    const translate = useTranslate();
    const { symbol: currencySymbol } = useCurrency();
    const isCallPrice = !calculatedPrice;
    const t1 = calculatedPrice || null;
    const t2 = cancellation || null;
    let t3;
    if ($[0] !== isCallPrice || $[1] !== t1 || $[2] !== t2) {
        t3 = {
            isCallPrice,
            calculatedPrice: t1,
            cancellation: t2
        };
        $[0] = isCallPrice;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
    }
    else {
        t3 = $[3];
    }
    const isImprint = useIsBankImprint(t3);
    let t4;
    if ($[4] !== isCallPrice || $[5] !== isImprint || $[6] !== translate) {
        t4 = capitalize(isCallPrice ? translate("messages.price") : isImprint ? translate("messages.bank_imprint") : translate("messages.total_price"));
        $[4] = isCallPrice;
        $[5] = isImprint;
        $[6] = translate;
        $[7] = t4;
    }
    else {
        t4 = $[7];
    }
    const label = t4;
    const priceValueNumeric = isCallPrice ? entity.callPrice.value : isImprint ? cancellation?.fees?.value : calculatedPrice?.total;
    let t5;
    if ($[8] !== currencySymbol || $[9] !== priceValueNumeric || $[10] !== translate) {
        t5 = priceValueNumeric && priceValueNumeric > 0 ? translate("messages.price_with_currency", {
            price: formatPrice(priceValueNumeric),
            currencySymbol
        }) : capitalize(translate("practical.call_price.free"));
        $[8] = currencySymbol;
        $[9] = priceValueNumeric;
        $[10] = translate;
        $[11] = t5;
    }
    else {
        t5 = $[11];
    }
    const priceValueContent = t5;
    let t6;
    if ($[12] !== entity || $[13] !== isCallPrice || $[14] !== translate) {
        t6 = isCallPrice && entity.callPrice.value > 0 && entity.callPrice.isConditional ? capitalize(translate("messages.price_from")) : null;
        $[12] = entity;
        $[13] = isCallPrice;
        $[14] = translate;
        $[15] = t6;
    }
    else {
        t6 = $[15];
    }
    const overTitle = t6;
    let t7;
    if ($[16] !== entity || $[17] !== isCallPrice || $[18] !== isImprint || $[19] !== modal || $[20] !== onOpenBookingDetailModal || $[21] !== translate) {
        t7 = isCallPrice ? entity.callPrice.value === 0 ? entity.callPrice.isConditional ? translate("messages.with_conditions") : null : translate("practical.price_range.per_adult") : !isImprint && !modal && onOpenBookingDetailModal && <MoreBookingDetail onOpenModal={onOpenBookingDetailModal} className="pr-0"/>;
        $[16] = entity;
        $[17] = isCallPrice;
        $[18] = isImprint;
        $[19] = modal;
        $[20] = onOpenBookingDetailModal;
        $[21] = translate;
        $[22] = t7;
    }
    else {
        t7 = $[22];
    }
    const subTitle = t7;
    let t8;
    if ($[23] !== calculatedPrice || $[24] !== currencySymbol || $[25] !== translate) {
        t8 = calculatedPrice?.totalPriceBeforeDiscount && calculatedPrice.totalPriceBeforeDiscount !== calculatedPrice.subTotal ? <span className="line-through text-lg mr-1" title={translate("messages.total_price_before_discount")}>{`${calculatedPrice.totalPriceBeforeDiscount}${currencySymbol}`}</span> : null;
        $[23] = calculatedPrice;
        $[24] = currencySymbol;
        $[25] = translate;
        $[26] = t8;
    }
    else {
        t8 = $[26];
    }
    const totalPriceBeforeDiscountContent = t8;
    let t9;
    if ($[27] !== label) {
        t9 = <span className="text-gray-400">{label}</span>;
        $[27] = label;
        $[28] = t9;
    }
    else {
        t9 = $[28];
    }
    const t10 = totalPriceBeforeDiscountContent ? totalPriceBeforeDiscountContent : overTitle;
    let t11;
    if ($[29] !== label || $[30] !== priceValueContent) {
        t11 = <span className="text-2.5xl" title={label}>{priceValueContent}</span>;
        $[29] = label;
        $[30] = priceValueContent;
        $[31] = t11;
    }
    else {
        t11 = $[31];
    }
    let t12;
    if ($[32] !== t10 || $[33] !== t11) {
        t12 = <span>{t10} {t11}</span>;
        $[32] = t10;
        $[33] = t11;
        $[34] = t12;
    }
    else {
        t12 = $[34];
    }
    let t13;
    if ($[35] !== t12 || $[36] !== t9) {
        t13 = <div className="flex justify-between items-center -mb-1">{t9}{t12}</div>;
        $[35] = t12;
        $[36] = t9;
        $[37] = t13;
    }
    else {
        t13 = $[37];
    }
    let t14;
    if ($[38] !== subTitle) {
        t14 = subTitle && <div className="flex justify-end text-gray-400">{subTitle}</div>;
        $[38] = subTitle;
        $[39] = t14;
    }
    else {
        t14 = $[39];
    }
    let t15;
    if ($[40] !== t13 || $[41] !== t14) {
        t15 = <div className="total-price py-2 flex flex-col text-sm border-t border-dashed border-gray-100 first:border-0 ">{t13}{t14}</div>;
        $[40] = t13;
        $[41] = t14;
        $[42] = t15;
    }
    else {
        t15 = $[42];
    }
    return t15;
};
export default BookingDetailMainPrice;
